import { render, staticRenderFns } from "./Event.view.vue?vue&type=template&id=6c710985&"
import script from "./Event.view.vue?vue&type=script&lang=js&"
export * from "./Event.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports